import {
  getPayoutMethods,
  getPendingPayouts,
  getLastPayoutDetails,
  getPayoutFee,
  searchBlockElements,
  getRolloverCheck,
  getStoredWireTransfers,
  getStoredEcheckPayout,
  clerkSearchPlayer,
  checkRollover,
} from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import { getPayoutPaymentRules } from '../../../utils/api';

Vue.use(Vuex);

const state = {
  selectedPayoutMethod: {},
  amount: 100,
  filteredActiveWireTransfer: [],
  filteredActiveEcheck: [],
  minAmount: 100,
  payoutMethods: [],
  blockElements: [],
  pendingPayouts: {},
  lastPendingPayouts: [],
  lastPendingPayoutsLoading: false,
  payoutFee: {},
  rollover: {
    error: false,
    message: '',
    handled: false,
  },
  rolloverRequestStatus: {
    loading: false,
    success: false,
    error: false,
  },
  payoutInputError: null,
  paymentRules: [],
  rolloverLoading: false,
  showPendingRolloverModal: false,
};

const getters = {
  getField,
};

const mutations = {
  updateField,
  setSelectedPayoutMethod(state, method) {
    state.selectedPayoutMethod = method;
  },
  setPayoutInputError(state, val) {
    state.payoutInputError = val;
  },
  setPayoutMethods(state, methods) {
    state.payoutMethods = methods;
  },
  setPendingPayouts(state, pendings) {
    state.pendingPayouts = pendings;
  },
  setPayoutFee(state, fee) {
    state.payoutFee = fee;
  },
  setBlockElements(state, arr) {
    state.blockElements = arr;
  },
  setLastPendingPayouts(state, payouts) {
    state.lastPendingPayouts = payouts;
  },
  setLastPendingPayoutsLoading(state, value) {
    state.lastPendingPayoutsLoading = value;
  },
  setFilteredActiveWireTransfer(state, arr) {
    state.filteredActiveWireTransfer = arr;
  },
  setFilteredActiveEcheck(state, arr) {
    state.filteredActiveEcheck = arr;
  },
  setRolloverLoading(state, value) {
    state.rolloverLoading = value;
  },
  setShowPendingRollover(state, value) {
    state.showPendingRolloverModal = value;
  },
  setRollover(state, row) {
    state.rollover = {
      ...state.rollover,
      ...row,
    };
  },
  setRolloverRequestStatus(state, row) {
    state.rolloverRequestStatus = {
      ...state.rolloverRequestStatus,
      ...row,
    };
  },
  setPaymentRules(state, data) {
    state.paymentRules = data;
  },
};

const actions = {
  tryGetPayoutPaymentRules({ commit }) {
    getPayoutPaymentRules().then(r => {
      if (r.data.IsSuccess) {
        const result = {};
        r.data.Data.map(raw => {
          result[raw.payment_type] = raw;
        });
        commit('setPaymentRules', result);
      }
    });
  },
  tryGetPayoutFee({ commit, state }, payload) {
    if (payload.amount < state.minAmount) {
      return;
    }
    getPayoutFee(payload.channel, payload.method, payload.amount).then(r => {
      if (r.data.IsSuccess) {
        const payoutFee = r.data.Data;
        commit('setPayoutFee', payoutFee);
      }
    });
  },
  tryGetPayoutMethods({ commit }) {
    getPayoutMethods().then(r => {
      if (r.data.IsSuccess) {
        const payoutMethodsData = r.data.Data;
        const filteredPayoutMethods = payoutMethodsData.enablePayoutsMethod;
        commit('setPayoutMethods', filteredPayoutMethods);
      }
    });
  },
  tryGetPendingPayouts({ commit }) {
    getPendingPayouts().then(r => {
      if (r.data.IsSuccess) {
        const pendingPayouts = r.data.Data;
        commit('setPendingPayouts', pendingPayouts);
      }
    });
  },
  tryGetLastPendingPayouts({ commit }) {
    commit('setLastPendingPayoutsLoading', true);
    getLastPayoutDetails().then(r => {
      if (r.data.IsSuccess) {
        const lastPendingPayoutsResponse = r.data.Data.payouts;
        commit('setLastPendingPayouts', lastPendingPayoutsResponse);
      }
      commit('setLastPendingPayoutsLoading', false);
    });
  },
  trySearchBlockElements({ commit }) {
    searchBlockElements({ type: 'payout', blocks: 1 }).then(r => {
      if (r.data.IsSuccess) {
        commit('setBlockElements', r.data.Data);
      }
    });
  },
  tryRequestRollover({ commit }) {
    commit('setRolloverRequestStatus', {
      loading: true,
      success: false,
      error: false,
    });
    getRolloverCheck().then(r => {
      if (r.data.IsSuccess) {
        commit('setRollover', {
          error: true,
          message: r.data.Data.error_code || r.data.Data.message,
          handled: true,
        });
      } else {
        commit('setRollover', {
          error: true,
          message: r.data.ExceptionMessage[0],
        });
      }
      commit('setRolloverRequestStatus', {
        loading: false,
        success: false,
        error: false,
      });
    });
  },
  tryGetStoredWireTransfers({ commit }) {
    getStoredWireTransfers().then(r => {
      if (r.data.IsSuccess) {
        // r.data.Data = [
        //   {
        //     "id": 5992,
        //     "account_type": "C",
        //     "active": true,
        //     "bank_account_number": "test",
        //     "bank_country": "AF",
        //     "bank_international_account_number": "test",
        //     "bank_name": "test",
        //     "bank_street_address": "4735  Bryan Avenue",
        //     "bank_state": "BD",
        //     "bank_city": "Montgomery",
        //     "bank_zip": "36104",
        //     "bank_phone_number": "3343200913",
        //     "bank_route_code": "test",
        //     "bank_sort_code": "test",
        //     "bank_swift_code": "test",
        //     "customer_account": "MB4017",
        //     "name_on_account": "test",
        //     "is_default": false,
        //     "is_approved": true,
        //     "created_at": "2019-01-24 11:47:18",
        //     "deleted_at": null,
        //     "updated_at": "2019-01-24 11:47:18",
        //     "created_by": "MB4017",
        //     "deleted_by": null,
        //     "updated_by": null,
        //     "bank_intermediaries": []
        //   },
        //   {
        //     "id": 5938,
        //     "account_type": "C",
        //     "active": true,
        //     "bank_account_number": "12345678prueba",
        //     "bank_country": "US",
        //     "bank_international_account_number": "iban--",
        //     "bank_name": "Prueba",
        //     "bank_street_address": "prueba 24",
        //     "bank_state": "AL",
        //     "bank_city": "Montgomery",
        //     "bank_zip": "241241",
        //     "bank_phone_number": "2134567890",
        //     "bank_route_code": "code--",
        //     "bank_sort_code": "code--",
        //     "bank_swift_code": "swif--",
        //     "customer_account": "MB4017",
        //     "name_on_account": "name--",
        //     "is_default": false,
        //     "is_approved": true,
        //     "created_at": "2019-01-23 14:39:33",
        //     "deleted_at": null,
        //     "updated_at": "2019-01-23 14:39:33",
        //     "created_by": "MB4017",
        //     "deleted_by": null,
        //     "updated_by": null,
        //     "bank_intermediaries": []
        //   },
        //   {
        //     "id": 5919,
        //     "account_type": "C",
        //     "active": true,
        //     "bank_account_number": "8888888888",
        //     "bank_country": "US",
        //     "bank_international_account_number": "12345",
        //     "bank_name": "Test_test",
        //     "bank_street_address": "1A",
        //     "bank_state": "AL",
        //     "bank_city": "Al",
        //     "bank_zip": "90210",
        //     "bank_phone_number": "8888888888",
        //     "bank_route_code": "888888888",
        //     "bank_sort_code": "12345",
        //     "bank_swift_code": "645646",
        //     "customer_account": "MB4017",
        //     "name_on_account": "John Doe12",
        //     "is_default": false,
        //     "is_approved": true,
        //     "created_at": "2019-01-23 11:50:10",
        //     "deleted_at": null,
        //     "updated_at": "2019-03-11 13:42:43",
        //     "created_by": "MB4017",
        //     "deleted_by": null,
        //     "updated_by": null,
        //     "bank_intermediaries": []
        //   }
        // ];
        commit('setFilteredActiveWireTransfer', r.data.Data);
      }
    });
  },
  tryGetStoredEcheck({ commit }) {
    getStoredEcheckPayout().then(r => {
      if (r.data.IsSuccess) {
        // r.data.Data = [
        //   {
        //     "id": 9973,
        //     "account_type": "S",
        //     "active": true,
        //     "bank_account": "8888888888",
        //     "bank_country": "CA",
        //     "bank_name": "Dominic Test",
        //     "bank_route_code": "051000017",
        //     "customer_account": "MB4017",
        //     "is_default": false,
        //     "is_approved": true,
        //     "created_at": "2019-03-25 13:15:42",
        //     "deleted_at": null,
        //     "updated_at": "2019-03-25 13:15:42",
        //     "created_by": "MB4017",
        //     "deleted_by": null,
        //     "updated_by": null
        //   },
        //   {
        //     "id": 3332,
        //     "account_type": "C",
        //     "active": true,
        //     "bank_account": "12341",
        //     "bank_country": "US",
        //     "bank_name": "test_test",
        //     "bank_route_code": "123412342",
        //     "customer_account": "MB4017",
        //     "is_default": false,
        //     "is_approved": true,
        //     "created_at": "2018-11-15 10:57:12",
        //     "deleted_at": null,
        //     "updated_at": "2019-03-11 13:41:01",
        //     "created_by": "MB4017",
        //     "deleted_by": null,
        //     "updated_by": null
        //     ,
        //   }
        // ]
        commit('setFilteredActiveEcheck', r.data.Data);
      }
    });
  },

  searchPlayer({ commit, rootState }) {
    const player = rootState.player.player;

    const request = {
      account_name: player.PlayerAccount,
      primary_email: player.Email,
      first_name: player.PlayerName,
      last_name: player.PlayerLastName,
    };

    clerkSearchPlayer(request).then(r => {
      if (r.data.IsSuccess) {
        commit('setClerkPlayerSearchResult', r.data.Data.data);
      }
    });
  },

  checkRollover({ commit, state }) {
    commit('setRolloverLoading', true);

    const request = {
      PayoutMethod: state.selectedPayoutMethod.pk_mstpayout_method,
      PayoutAmount: state.amount,
    };

    return checkRollover(request)
      .then(response => {
        // Mock data

        // response.data = {
        //   status: 'error',
        //   error: 'Payout Rejected. Incomplete Rollover.',
        //   message:
        //     'Whoops! You still have a pending rollover. Once completed, we will  be able to process your payout request.',
        //   detail: 'Pending RO',
        //   error_code: 'RO_CHECK_REJECTED',
        // };

        if (response.data.status === 'ok') {
          commit('setShowPendingRollover', false);
        } else {
          commit('setShowPendingRollover', true);
        }
        return response.data.status;
      })
      .finally(() => commit('setRolloverLoading', false));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
